<template>
  <div class="budget-material-select hmd-btn">
    <a-button type="primary" :disabled="!projectId" @click="showModal">源单导入</a-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { LibraryListRecord } from "@/views/material/library/library.interface";
import MaterialTable from "./material-table/index.vue";
import SelectedTable from "./selected-table/index.vue";
import { hmdConfirm } from "@/dialog/index";
/**
 * 施工预算材料选择
 */
export default defineComponent({
  name: "BudgetMaterialSelect",
  components: { MaterialTable, SelectedTable },
  props: {
    projectId: { type: String, default: "" },
    value: { type: Array as PropType<string[]>, default: () => [] },
    hideColumn: { type: Array as PropType<any[]>, default: () => [] },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive<{
      visible: boolean;
      currentMaterialList: LibraryListRecord[];
    }>({
      visible: false,
      currentMaterialList: [],
    });

    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          //@ts-ignore
          projectId:props.projectId,
          value:props.value,
          hideColumn:props.hideColumn,
        },
        confirm:({res})=>{
          let {ids,currentMaterialList}=res
          emit("update:value", ids);
          emit("change", currentMaterialList);
        }
      });
    };

    return {
      ...toRefs(state),
      showModal
    };
  },
});
</script>

<style lang="less" scoped>
.budget-material-select {
  display: inline-block;
}
</style>

<style lang="less">
.budget-material-select__modal {
  position: relative;
  padding: 0 415px 0 0;
  min-height: 500px;

  &__right {
    position: absolute;
    top: 0;
    height: 100%;
    overflow-y: auto;
  }

  &__right {
    right: 0;
    width: 400px;
  }
}
</style>
